module.exports = __webpack_public_path__ + "img/2.27eeddb8.png";